import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
export const styles = {
  pill: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x18g2hj5",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x13s4r1c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    fontSize: "x1dcheo9",
    fontWeight: "xlr2uoh",
    color: "xtt1gjl",
    $$css: true
  },
  bgPublic: {
    backgroundColor: "x19tgrng",
    $$css: true
  },
  bgAges: {
    backgroundColor: "x15xno7f",
    $$css: true
  },
  bgGender: {
    backgroundColor: "x1gvq2gg",
    $$css: true
  },
  iconPublic: {
    color: "x18yk8ih",
    $$css: true
  },
  iconAges: {
    color: "x1gonuu0",
    $$css: true
  },
  iconGender: {
    color: "xarw3lm",
    $$css: true
  }
};